import React from 'react';
import { Avatar, User } from '@heroui/react';
import {
  Link,
  Navbar,
  NavbarContent,
  NavbarItem,
  NavbarMenu,
  NavbarMenuItem,
  NavbarMenuToggle
} from '@heroui/react';
import { Box } from '@/shared/ui/styles/Box';
import { NotificationsDropdown } from './NotificationsDropdown';
import { DynamicBreadcrumbs } from './DynamicBreadcrumbs';
import { useSidebarContext } from '@/app/layouts/layout-context';
import { useAppStore } from '@/shared/lib/store';

interface NavbarWrapperProps {
  children: React.ReactNode;
}

export const NavbarWrapper: React.FC<NavbarWrapperProps> = ({ children }) => {
  const { setCollapsed } = useSidebarContext();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { user } = useAppStore();
  
  const collapseItems = [
    'Profile',
    'Dashboard',
    'Activity', 
    'Analytics',
    'System',
    'Deployments',
    'My Settings',
    'Team Settings',
    'Help & Feedback',
    'Log Out',
  ];

  return (
    <Box className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
      <Navbar
        isBordered
        isMenuOpen={isMenuOpen}
        onMenuOpenChange={setIsMenuOpen}
        classNames={{
          wrapper: "w-full max-w-full px-0 h-16",
          base: "border-b border-divider bg-background",
        }}
      >
        {/* Mobile menu toggle */}
        <NavbarContent className="md:hidden basis-auto gap-2 px-4" justify="start">
          <NavbarItem>
            <button
              onClick={setCollapsed}
              className="flex flex-col justify-around w-6 h-6 bg-transparent border-none cursor-pointer p-0 focus:outline-none"
            >
              <div className="w-6 h-px bg-default-900 rounded-xl transition-all"></div>
              <div className="w-6 h-px bg-default-900 rounded-xl transition-all"></div>
            </button>
          </NavbarItem>
        </NavbarContent>
        {/* Breadcrumbs - Desktop only */}
        <NavbarContent className="hidden md:flex flex-1 gap-4 px-6" justify="start">
          <NavbarItem>
            <DynamicBreadcrumbs />
          </NavbarItem>
        </NavbarContent>

        {/* Right side actions */}
        <NavbarContent className="basis-auto gap-6 px-6" justify="end">
          {/* Notifications */}
          <NavbarItem>
            <NotificationsDropdown />
          </NavbarItem>

          <NavbarItem>
            <Avatar
              src={user?.avatar || "https://picsum.photos/id/1005/150/150"}
              size="md"
              isBordered
              color="secondary"
              className="transition-transform hover:scale-105"
            />
          </NavbarItem>
        </NavbarContent>
      </Navbar>

      {/* Main content area */}
      <main className="flex-1 p-6 bg-background">
        {children}
      </main>
    </Box>
  );
};